module.exports = __webpack_public_path__ + "static/img/steZh.301cde3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steZh.png
// module id = DOc3
// module chunks = 1